import { render, staticRenderFns } from "./LoyaltyProgram.vue?vue&type=template&id=61facc27&scoped=true"
import script from "./LoyaltyProgram.vue?vue&type=script&lang=ts"
export * from "./LoyaltyProgram.vue?vue&type=script&lang=ts"
import style0 from "./LoyaltyProgram.vue?vue&type=style&index=0&id=61facc27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61facc27",
  null
  
)

export default component.exports